export enum IntegrationActions {
  GET_DATA = "get_integration",
  SET_DATA = "set_integration",
  SET_LOADING = "set_integrations_loading",
  CLEAR_STATE = "clear_integration_state",

  CREATE_INTEGRATION = "create_integration",
}
